module.exports = {
    "Empty": `Tomt`
};


//# sourceMappingURL=sv-SE.main.js.map
